import cn from 'classnames';
import React from 'react';
import { MdDeleteForever } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { NotificationIcon } from '../../../assets/svg/notification';
import { IconButton } from '../../../components/icon-button/icon-button';
import { Label } from '../../../components/label/label';
import { Rating } from '../../../components/rating/rating';
import { concatPath } from '../../../helpers/path';
import { useIsMobile } from '../../../hooks/use-is-mobile';
import { ManagerPath, NotificationsPath, RootPath } from '../../../routes/manager/manager-enums';
import { Tooltip } from '../../tooltip/tooltip';
import { decodeHTML, notifMap } from '../notification-helpers';
import { useNotifications } from '../use-notifications';
import s from './desktop-notifications.module.css';

export const DesktopNotifications = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { handleRemoveNotification, notifications, t } = useNotifications();
  const trigger = (
    <NotificationIcon unread={notifications.some((item) => !item.read)} className={s.icon} />
  );

  if (isMobile) {
    return React.cloneElement(trigger, {
      onClick: () => {
        navigate(concatPath([RootPath.Manager, ManagerPath.Notifications, NotificationsPath.All]));
      },
    });
  }

  return (
    <Tooltip trigger={trigger} offset={12}>
      <ul className={s.list}>
        {notifications.length ? (
          notifications.map(({ rate, body, id, type, read }) => (
            <li key={id} className={cn(s.item, read && s.read)}>
              <Label className={s.label}>
                {t(notifMap[type])}
                <IconButton
                  size="sm"
                  variant="secondary"
                  onClick={() => handleRemoveNotification(id)}
                >
                  <MdDeleteForever />
                </IconButton>
              </Label>
              {rate && <Rating rate={rate} />}
              <p dangerouslySetInnerHTML={{ __html: decodeHTML(body) }} />
            </li>
          ))
        ) : (
          <li className={s.item}>{t('Уведомлений нет')}</li>
        )}
      </ul>
    </Tooltip>
  );
};
